import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
// import Echo from 'laravel-echo'
import BootstrapVue from 'bootstrap-vue'
import globals from './globals'
import Popper from 'popper.js'
import VueInsProgressBar from 'vue-ins-progress-bar'
import Iconify from '@iconify/iconify'

const options = {
  position: 'fixed',
  show: true,
  height: '3px'
}

Vue.use(VueInsProgressBar, options)
Vue.use(Iconify)
// import Init from './init.js'

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.prototype.$http = axios
Vue.config.productionTip = false

Vue.use(BootstrapVue)

// Global RTL flag
Vue.mixin({
  data: globals
})

const userToken = localStorage.getItem('userToken')
if (userToken) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer' + userToken
}

axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://localhost/al-tarik/'
axios.defaults.baseURL = 'https://adminapi.al-tarik.ly/'

store.dispatch('profile').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
